
<template>

	<elements
		ref="objects"
		service="cadastral_objects"
		style="min-height: 100%;"
		without_add
		without_back_button
		:attrs="attrs"
		:get_many_extra="{ group : id }"
		not_able_for_delete
		emit_on_double_click_element
		essence_name_genetive_case="объекта"
		essence_name_for_plural_1="объект"
		essence_name_for_plural_234="объекта"
		essence_name_for_plural_others="объектов"
		:elements_table_height="elements_table_height"
		:postfix_for_storage_name="`details_${id}`"
	>

		<template v-slot:modal_dialogs>

			<setCoefs ref="set_coefs" :id="id" :data="data"/>

		</template>

		<template v-slot:nav_items_before_export>

			<b-button variant="outline-primary" v-on:click="set_coefs" title="Веса" v-b-tooltip:fullscreen.hover.bottomright><base-icon name="scales"/></b-button>

			<b-button v-if="check_roles([ 'cost' ])" variant="outline-primary" v-on:click="set_cost" title="Рассчитать итоговую кадастровую стоимость" v-b-tooltip:fullscreen.hover.bottomright><base-icon name="calc"/></b-button>

		</template>

	</elements>

</template>

<script>

import api from "../../../../api"
import elements from "../../../elements"
import setCoefs from "./set_coefs"

export default
{
	props :
	{
		id : String,
		data : Object,
	},

	components :
	{
		elements,
		setCoefs,
	},

	data()
	{
		var attrs =
			[
				{
					attr_key : "attrs.CadastralNumber",
					visible : true,
					visible_if_no_visible : true,
					is_cadastral_number : true,
				},
				{
					attr_key : "attrs.Area",
					visible : true,
					visible_if_no_visible : true,
				},
				{
					attr_key : "attrs.cost",
					visible : true,
					visible_if_no_visible : true,
					my_formatter : elem => { return { value : api.format_cost(elem.value, "", "") } },
				},
				{
					attr_key : "attrs.UPKS",
					visible : true,
					visible_if_no_visible : true,
					my_formatter : elem => { return { value : api.format_cost(elem.value, "", "") } },
				},
			]

		if(api.has_oks())
		{
			attrs.push(
				{
					attr_key : "attrs.DegreeReadiness",
					visible : false,
				})
		}

		if(this.data.cost_evaluation_comparative)
		{
			attrs.push(
				{
					attr_key : "attrs.cost_comparative",
					visible : false,
					my_formatter : elem => { return { value : api.format_cost(elem.value, "", "") } },
				})
			attrs.push(
				{
					attr_key : "attrs.UPKS_comparative",
					visible : false,
					my_formatter : elem => { return { value : api.format_cost(elem.value, "", "") } },
				})
		}

		if(this.data.cost_evaluation_expensive)
		{
			attrs.push(
				{
					attr_key : "attrs.cost_expensive",
					visible : false,
					my_formatter : elem => { return { value : api.format_cost(elem.value, "", "") } },
				})
			attrs.push(
				{
					attr_key : "attrs.UPKS_expensive",
					visible : false,
					my_formatter : elem => { return { value : api.format_cost(elem.value, "", "") } },
				})
		}

		if(this.data.cost_evaluation_profitable)
		{
			attrs.push(
				{
					attr_key : "attrs.cost_profitable",
					visible : false,
					my_formatter : elem => { return { value : api.format_cost(elem.value, "", "") } },
				})
			attrs.push(
				{
					attr_key : "attrs.UPKS_profitable",
					visible : false,
					my_formatter : elem => { return { value : api.format_cost(elem.value, "", "") } },
				})
		}

		return {

			elements_table_height : "100%",
			attrs : attrs,

		}
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		set_coefs()
		{
			this.$refs.set_coefs.execute()
		},

		set_cost()
		{
			var calculation_types = []
			if (this.data.cost_evaluation_comparative) calculation_types.push("Сравнительный подход")
			if (this.data.cost_evaluation_expensive) calculation_types.push("Затратный подход")
			if (this.data.cost_evaluation_profitable) calculation_types.push("Доходный подход")

			api.call_long_operation(this, "Группа / Множественное редактирование / Расчеты / Расчет кадастровой стоимости", "cadastral_groups", "set_cost",
				{ id : this.id, calculation_types : calculation_types },
				response =>
				{
					api.open_response_url(response)

					this.$refs.objects.refresh()
				},
				{ success_msg : "Расчет итоговой КС завершен" }
			)
		}
	}
}

</script>

